import React from "react";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

// const today = dayjs();
// const todayStartOfTheDay = today.startOf('day');
const currentDateTime = dayjs();
const currentHour = currentDateTime.hour();
const currentMinute = currentDateTime.minute();
export default function BasicTimePicker() {
  const defaultValue = dayjs().hour(currentHour).minute(currentMinute);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        defaultValue={defaultValue}
        slotProps={{ textField: { size: "small" } }}
      />
    </LocalizationProvider>
  );
}
